// extracted by mini-css-extract-plugin
export default {"defaultCounterCount":"CounterButton_defaultCounterCount__DdlPo"};